// 取引先IDと店舗IDを使って２つのデータを比較
export const compareDataByShopId = (data_a, data_b) =>  {
    if (data_a.customer_id > data_b.customer_id) {
      return 1;
    }
    if (data_a.customer_id < data_b.customer_id) {
      return -1;
    }
    if (data_a.shop_id > data_b.shop_id) {
      return 1;
    }
    if (data_a.shop_id < data_b.shop_id) {
      return -1;
    }
    return 0;
  }

// 取引先ごと、選択中の店舗を抽出
export const getSelectingCustomerShopList = (customerShopList) => {
  return customerShopList.map((customerData) => ({
    customer_id: customerData.customer_id,
    customer_name: customerData.customer_name,
    selected_shop_list: customerData.shop_list.filter((shopData) => shopData.is_selected)
  }));
}